import { routes } from '../routes';

// Where a sport player who was never photographed on their own is sent: their
// team picture page, not the favorites gallery, which would ask them to pick a
// favourite out of one landscape team shot. 87 of the 134 players in the first
// sportsfall2027 run were in that position.
//
// ONE implementation, used by both doors into the purchase flow: the package
// picker (PackageSelection) and the emailed package link (Sittings). The email
// door was missed when the page shipped (#5693), so a parent clicking the
// campaign email still landed on the gallery.
//
// Every input is the SERVER's answer: `isSport` is SportSeason.sport? through
// Api::PackageResource, `sportGroupPhotoOnly` / `sportGroupPoseIds` are
// StudentImage#sport_group_poses -- the one implementation of the slot rule. No
// season string and no pose number is parsed here.

// Was this player photographed only in group pictures -- team, buddy or both,
// no portrait? `sportGroupPhotoOnly` is the server's answer
// (StudentImage#sport_group_photo_only?); `sportTeamPhotoOnly`, the narrower
// one it superseded, is still read for a caller that asked only for it.
export const groupPhotoOnly = (studentImage) => Boolean(
  studentImage && (studentImage.sportGroupPhotoOnly || studentImage.sportTeamPhotoOnly),
);

// Every picture the page should sell, in the server's order (team first, then
// buddy). Falls back to the team-only ids, then the single id, for a caller
// that asked only for those.
export const sportTeamPoseIds = (studentImage) => {
  if (!studentImage) return [];

  const groupIds = (studentImage.sportGroupPoseIds || []).filter(Boolean);
  if (groupIds.length > 0) return groupIds;

  const ids = (studentImage.sportTeamPoseIds || []).filter(Boolean);
  if (ids.length > 0) return ids;

  return studentImage.sportTeamPoseId ? [studentImage.sportTeamPoseId] : [];
};

// Null means "route the ordinary way". Without a pose id there is nothing to
// put in the frame, and the gallery -- which lists whatever the player does
// have -- stays the right page.
export const sportTeamPictureRoute = (packageItem, studentImage) => {
  if (!packageItem || !packageItem.isSport) return null;
  if (!groupPhotoOnly(studentImage)) return null;

  const ids = sportTeamPoseIds(studentImage);
  if (ids.length === 0) return null;

  return routes.sportsTeamPicture(packageItem.id, {
    favorites: ids.length === 1 ? ids[0] : ids,
  });
};

// Where a link that names a pricelist (`package=<id>`, every campaign email)
// lands once the email is known.
export const packageLinkDestination = (packageItem, studentImage) => (
  sportTeamPictureRoute(packageItem, studentImage)
    || routes.elementaryMultiPoseBuilder(packageItem.id)
);
